import { render, staticRenderFns } from "./CustomerRegistrations.vue?vue&type=template&id=50f16cce&scoped=true&"
import script from "./CustomerRegistrations.vue?vue&type=script&lang=js&"
export * from "./CustomerRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRegistrations.vue?vue&type=style&index=0&id=50f16cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f16cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f16cce')) {
      api.createRecord('50f16cce', component.options)
    } else {
      api.reload('50f16cce', component.options)
    }
    module.hot.accept("./CustomerRegistrations.vue?vue&type=template&id=50f16cce&scoped=true&", function () {
      api.rerender('50f16cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/CustomerRegistrations.vue"
export default component.exports